import type { IAddress, IAddressBook } from '@/types';
import { Flex, Radio, RadioGroup, Stack, Text, useControllableState } from '@chakra-ui/react';
import { useController } from 'react-hook-form';
import { AddDeliveryAddress } from './AddDeliveryAddress';

interface IDeliveryAddressSelectorFormProps {
  addressBook: IAddressBook[];
  onClose: () => void;
  userAddress: IAddress;
  userName: string;
}

export const DeliveryAddressSelector: React.FC<IDeliveryAddressSelectorFormProps> = (
  props
): JSX.Element => {
  const { addressBook, onClose } = props;
  const [deliveryAddress, setDeliveryAddress] = useControllableState({ defaultValue: 0 });

  const { field: deliveryAddressField } = useController({
    name: 'deliveryAddress',
    defaultValue: { ...addressBook[0] },
  });

  return (
    <>
      <RadioGroup
        id="deliveryAddress"
        value={deliveryAddress}
        onChange={(nextVal): void => {
          setDeliveryAddress(+nextVal);

          deliveryAddressField.onChange({
            name: addressBook[+nextVal].name,
            city: addressBook[+nextVal].city,
            isPrivateHome: addressBook[+nextVal].isPrivateHome,
            countryCode: addressBook[+nextVal].countryCode,
            province: addressBook[+nextVal].province,
            streetAddress: addressBook[+nextVal].streetAddress,
            zipCode: addressBook[+nextVal].zipCode,
          });
        }}
      >
        <Stack>
          {addressBook.map((address, i) => (
            <Radio key={i.toString()} value={i} variant="mbe">
              <Flex direction="column" gap={2} mb={4} ml={2}>
                <Text as="span" fontSize={18} fontWeight="bold">
                  {address.name}
                </Text>

                <Text fontSize={18}>
                  {address.streetAddress} {address.zipCode} {address.city} {address.province}
                </Text>
              </Flex>
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
      <AddDeliveryAddress onClose={(): void => onClose()} />
    </>
  );
};
